import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {MatRipple, RippleAnimationConfig} from '@angular/material/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-dl-checkbox',
    templateUrl: './dl-checkbox.component.html',
    styleUrls: ['./dl-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DlCheckboxComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DlCheckboxComponent implements OnInit, ControlValueAccessor {
    @ViewChild(MatRipple) ripple!: MatRipple;
    @Input() checked!: Boolean;
    @Output() onChangeEvent = new EventEmitter<boolean>();
    rippleAnimationConfig: RippleAnimationConfig = {
        enterDuration: 150,
        exitDuration: 150,
    };
    rippleConfig = {
        persistent: true,
        centered: true,
        animation: this.rippleAnimationConfig,
        radius: 14,
        color: 'rgba(0,0,0,.04)',
    };

    constructor() {
    }

    ngOnInit(): void {
    }

    onModelChange($event: boolean): void {
        this.checked = $event;
        this.onChangeEvent.emit($event);
    }

    onChange: any = () => {
    }
    onTouch: any = () => {
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    writeValue(checked: boolean): void {
        this.checked = checked;
        this.onChange(checked);
    }

    launchRipple(): void {
        this.ripple.launch({
            ...this.rippleConfig
        });
    }

    fadeOutRipple(): void {
        this.ripple.fadeOutAll();
    }
}
